<template>
  <div>
    <form  @submit.prevent="property.uuid ? editSubmitFn() : submitFn()">
      <div class="mb-10">
        <label for="" class="text-main text-opacity-50 text-sm block mb-5">Property For *</label>
        <div class="flex">
          <span class="radio-selection">
            <input type="radio" v-model="property.property_for"  value="Sale" name="propertyFor" id="sale" class="hidden">
            <label for="sale" class="bg-gray-100 py-3 px-6 text-main rounded-xl  pills mr-3"> Sale </label>
          </span>
            <span class="radio-selection">
            <input type="radio" v-model="property.property_for" value="Rental" name="propertyFor" id="rent" class="hidden">
            <label for="rent" class="bg-gray-100 py-3 px-6 text-main rounded-xl  pills"> Rental </label>
          </span>
        </div>
      </div>
        <div class="mb-10">
        <label for="" class="text-main text-opacity-50 text-sm block mb-5">Property From *</label>
        <div class="flex">
          <span class="radio-selection">
            <input type="radio" v-model="property.property_from" name="propertyFrom" value="Owner" id="owner" class="hidden">
            <label for="owner" class="bg-gray-100 py-3 px-6 text-main rounded-xl  pills mr-3"> Owner </label>
          </span>
            <span class="radio-selection">
            <input type="radio" v-model="property.property_from" name="propertyFrom" value="Developer" id="developer" class="hidden">
            <label for="developer" class="bg-gray-100 py-3 px-6 text-main rounded-xl  pills mr-3"> Developer </label>
          </span>
          <span class="radio-selection">
            <input type="radio" v-model="property.property_from" name="propertyFrom" value="CP" id="CP" class="hidden">
            <label for="CP" class="bg-gray-100 py-3 px-6 text-main rounded-xl  pills mr-3"> CP </label>
          </span>
          <span class="radio-selection" v-if="propertyKeysList && propertyKeysList.broker_button && property.property_from ==='CP'">
            <input type="button" id="Add CP" class="hidden cursor-pointer" @click="showBrokerForm = true">
            <label for="Add CP" class="bg-gray-100 py-3 px-6 text-main rounded-xl  pills cursor-pointer"> Add Broker </label>
          </span>
        </div>
      </div>
      <div class="mb-6 relative" v-if="property.property_from ==='CP'">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Broker</label>
        <select v-model="property.broker_id" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
          <option selected disabled>Select</option>
          <option
            v-for="(br, key) in brokersList"
            :key="key"
            :value="br.id"
          >{{br.name}}</option>
        </select>
      </div>
      <div class="mb-6 relative" v-if="showProjectFields">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Project</label>
        <select v-model="property.project_id" @change="getProjectDetails(property.project_id)" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
          <option selected :value="null">Select the type</option>
          <option
            v-for="(pr, key) in propertyKeysList.projects"
            :key="key"
            :value="pr.id"
          >{{pr.text}}</option>
        </select>
      </div>
      <div class="mb-6 relative">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Building Type *</label>
        <select v-model="property.building_type" required class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
          <option selected disabled>Select the type</option>
          <option
            v-for="(bt, key) in propertyKeysList.building_types"
            :key="key"
            :value="bt"
          >{{bt}}</option>
        </select>
      </div>
        <div class="mb-6 relative">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Type *</label>
        <select v-model="property.property_type" required class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
          <option selected disabled>Select the type</option>
          <option
            v-for="(pt, key) in propertyType"
            :key="key"
            :value="pt"
          >{{pt}}</option>
        </select>
      </div>
      <div class="mb-6 relative" v-if="!isPlot">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Configuration</label>
        <select v-model="property.configuration" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
          <option selected disabled>Select Configuration</option>
          <option
            v-for="(c, key) in propertyKeysList.configuration"
            :key="key"
            :value="c"
          >{{c}}</option>
        </select>
      </div>
      <div class="mb-6 relative" v-if="is_rental">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Deposit Amount</label>
        <input type="number" v-model="property.deposit_amount" placeholder="Deposit Amount" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
      </div>
              <div v-if="propertyKeysList && (!propertyKeysList.is_executive && propertyKeysList.is_hide_owner_details)">
      <div class="mb-6 relative">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">
          Owner <span v-if="propertyKeysList.prop_owner_name_req" class="text-red-500">*</span>
        </label>
        <input type="text" v-model="property.owner" placeholder="Owner Name" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
      </div>
      <div class="mb-6 relative">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">
          Owner Contact <span v-if="propertyKeysList.prop_owner_contact_req" class="text-red-500">*</span>
        </label>
        <input type="number" v-model="property.owner_contact" placeholder="Owner Contact" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
      </div>
      <div class="mb-6 relative">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Other Contact</label>
        <input type="number" v-model="property.other_contacts" placeholder="Other Contact" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
      </div>
      </div>
      <div class="mb-6 relative" v-if="showProjectFields">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">{{ isPlot ? 'Plot Location' : 'Project/Location' }} *</label>
        <input
          type="text"
          required
          id="autoPl"
          v-model="property.project_name"
          class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none"
          placeholder="Start typing location"
          @input="getAddressData"
        >
      </div>
      <div class="mb-6 relative">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Landmark</label>
        <input type="text" v-model="property.landmark" id="landmark" name="landmark" placeholder="Enter" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
      </div>
      <div class="mb-6 relative">
        <label for=""
          class="text-main text-opacity-80 text-sm block mb-2 bg-white">Property Address</label>
        <textarea v-model="property.property_address" placeholder="Property Address" rows="2"
          class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none"></textarea>
      </div>
        <div class="mb-6 relative" v-if="!isPlot">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Possession Status</label>
        <select v-model="property.posession_status" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
          <option selected disabled>Select</option>
          <option
            v-for="(c, key) in propertyKeysList.posesstion_status"
            :key="key"
            :value="c"
          >{{c}}</option>
        </select>
      </div>
      <div class="mb-6 relative" v-if="!isPlot">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Possession Date</label>
                  <input type="date" v-model="property.possession_date" placeholder="Possession Date" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
      </div>
      <div class="mb-6 relative">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Land Type</label>
        <select v-model="property.land_type" @change="toggleLeaseTypeField" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
          <option selected disabled>Select Land Type</option>
          <option
            v-for="(lt, key) in propertyKeysList.land_types"
            :key="key"
            :value="lt"
          >{{lt}}</option>
        </select>
      </div>

      <div class="mb-6 relative" v-if="showLeaseTypeField">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Lease Type</label>
        <select v-model="property.lease_type" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
          <option selected disabled>Select Lease Type</option>
          <option
            v-for="(lt, key) in propertyKeysList.lease_types"
            :key="key"
            :value="lt"
          >{{lt}}</option>
        </select>
      </div>

      <div class="mb-6 relative">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Zone</label>
        <select v-model="property.zone" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
          <option selected disabled>Select Zone</option>
          <option
            v-for="(z, key) in propertyKeysList.zones"
            :key="key"
            :value="z"
          >{{z}}</option>
        </select>
      </div>

      <div class="mb-6 relative" v-if="showProposalFor">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Proposal For</label>
        <select v-model="property.proposal_for" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
          <option selected disabled>Select Proposal For</option>
          <option
            v-for="(pf, key) in propertyKeysList.proposal_fors"
            :key="key"
            :value="pf"
          >{{pf}}</option>
        </select>
      </div>
      <div class="mb-6 relative">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Status</label>
        <select v-model="property.status" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
          <option selected disabled>Select</option>
          <option
            v-for="(s, key) in propertyKeysList.status"
            :key="key"
            :value="s"
          >{{s}}</option>
        </select>
      </div>
      <div class="mb-6 relative">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Source</label>
        <select v-model="property.property_source_id" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
          <option selected disabled>Select</option>
          <option
            v-for="(p, key) in propertyKeysList.property_source"
            :key="key"
            :value="p.id"
          >{{p.name}}</option>
        </select>
      </div>
      <div class="mb-6 relative" v-if="showUserDropdown">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Property Sourced By</label>
        <select v-model="property.user_id" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
          <option selected disabled>Select User</option>
          <option
            v-for="(user, key) in propertyKeysList.users"
            :key="key"
            :value="user.id"
          >{{user.name}}</option>
        </select>
      </div>
      <div class="mb-6 relative" v-if="propertyKeysList && propertyKeysList.reference_source_ids && propertyKeysList.reference_source_ids.includes(property.property_source_id)">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Referal Name</label>
        <input type="text" v-model="property.referal_name" placeholder="Referal Name" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
      </div>
      <div class="mb-6 relative" v-if="propertyKeysList && propertyKeysList.reference_source_ids && propertyKeysList.reference_source_ids.includes(property.property_source_id)">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Referal Contact</label>
        <input type="number" v-model="property.referal_mobile" placeholder="Referal Contact" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
      </div>
      <div class="mb-6 relative">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Area Unit *</label>
        <select v-model="property.area_unit" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
          <option selected disabled>Select</option>
          <option
            v-for="(a, key) in propertyKeysList.area_units"
            :key="key"
            :value="a"
          >{{a}}</option>
        </select>
      </div>
      <div class="mb-6 relative">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Priority</label>
        <select v-model="property.priority" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
          <option selected disabled>Select</option>
          <option
            v-for="(p, key) in propertyKeysList.priorities"
            :key="key"
            :value="p"
          >{{p}}</option>
        </select>
      </div>
      <div class="mb-6 relative" v-if="!isPlot">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Oc Received</label>
        <select v-model="property.oc_received" class="border border-inputBorder p-4 w-full z-auto custom-select focus:outline-none rounded-xl">
          <option selected disabled value="">Select</option>
          <option :value="true">Yes</option>
          <option :value="false">No</option>
        </select>
      </div>
        <div class="mb-6 relative" v-if="!isPlot">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Builtup Area</label>
        <input type="number" step="any" v-model="property.builtup_area" placeholder="Enter in selected Area Unit" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
      </div>
      <div class="mb-6 relative">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">{{ isPlot ? 'Plot Area' : 'Carpet Area * (Note: Less than Builtup Area)' }} </label>
        <input type="number" step="any" v-model="property.carpet_area"  required placeholder="Enter in selected Area Unit" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
      </div>
      <div class="mb-6 relative" v-if="!isPlot">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Property Age</label>
        <input type="number" v-model="property.property_age" placeholder="Property Age" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
      </div>
      <div class="mb-6 relative" v-if="!isPlot">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Property Approved by</label>
        <input type="text" v-model="property.property_approve_by" placeholder="Property Approved by" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
      </div>
      <div class="mb-6 relative">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Expected Price *</label>
        <input type="number" v-model="property.expected_price" required placeholder="Enter in lacs" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
      </div>
      <div class="mb-6 relative" v-if="!isPlot">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Car parking charges </label>
        <input type="number" v-model="property.car_parking_charge" placeholder="Enter car parking charge" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
      </div>
      <div class="mb-6 relative" v-if="!isPlot">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Per square ft rate </label>
        <input type="number" v-model="property.base_cost_rate" placeholder="Enter Per square ft rate" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
      </div>
      <div class="mb-6 relative" v-if="!isPlot">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Maintainance Cost</label>
        <input type="number" v-model="property.maintenance_cost" placeholder="Enter" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
      </div>
      <div class="mb-6 relative" v-if="!isPlot">
        <label for="" class="text-main text-opacity-80 text-sm block mb-2 bg-white">Rera No</label>
        <input type="text" v-model="property.rera_no" placeholder="Enter" class="border text-sm border-inputBorder rounded-xl p-4 w-full z-auto focus:outline-none">
      </div>
      <div class="mt-10">
        <button type="submit" :disabled="!showProceed" class="bg-primary text-base font-semibold text-white rounded-xl p-5 w-full disabled:opacity-50" >Next</button>
      </div>
    </form>
          <Modal v-model="showBrokerForm">
      <div class="flex flex-col bg-white p-5 mx-4 overflow-x-scroll">
        <h3 class="text-primary font-semibold text-xs uppercase tracking-ct mb-4 block w-full">Add Broker</h3>
        <BrokerForm @broker-submitted="getBrokers" />
      </div>
            </Modal>
  </div>
</template>

<script>
import { propertyEnums } from '@/assets/scripts/enumMaps';
import BrokerForm from '@/components/CP/Form.vue';
import Modal from '@/components/Common/Modal.vue';

export default {
  components: {
    BrokerForm,
    Modal
  },
  props: {
    property: {
      type: Object,
      required: true
    },
    submitFn: {
      type: Function,
    },
    editSubmitFn: {
      type: Function,
    }
  },
  data() {
    return {
      showLeaseTypeField: false,
      enumMaps: propertyEnums,
      showBrokerForm: false,
      brokersList: [],
    }
  },
  created() {
    this.getBrokers();
  },
  methods: {
    async getBrokers() {
      const response = await this.$axios.get('mobile_crm/brokers');
      this.brokersList = response.data.brokers;
      this.showBrokerForm = false;
    },
    toggleLeaseTypeField() {
      this.showLeaseTypeField = this.property.land_type === 'Lease Hold';
    },
    getProjectDetails(id) {
      if (id) {
        this.$axios.get(`mobile_crm/properties/get_project_details?project_id=${id}`)
        .then((res) => {
          this.property.posession_status = res.data.possession_status
          this.property.possession_date = res.data.possession_date
          this.property.property_age = res.data.property_age
          this.property.rera_no = res.data.rera_no
          this.property.property_approve_by = res.data.project_approve_by
          this.property.city_id = res.data.city_id
          this.property.locality_id = res.data.locality_id
          if (res.data.location) {
            this.property.project_name = res.data.location
            this.property.lat = res.data.lat
            this.property.long = res.data.long
          }
          if (res.data.amenity_ids) {
            this.property.amenity_ids = res.data.amenity_ids
          }
        })
        .catch((err) => console.log(err));
      }
    },
    getAddressData(event){
      // Simple location input handling
      this.property.project_name = event.target.value;
    }
  },
  computed: {
    showProposalFor() {
      if (!this.property || !this.property.building_type) return false;
      const restrictedTypes = ["Residential", "Commercial"];
      return !restrictedTypes.includes(this.property.building_type);
    },
    showProjectFields() {
      if (!this.property || !this.property.building_type) return false;
      const restrictedTypes = ["Plot"];
      return !restrictedTypes.includes(this.property.building_type);
    },
    isPlot() {
      return this.property.building_type === 'Plot'  
    },
    is_rental() {
      return this.property.property_for === 'Rental'
    },
    showUserDropdown() {
      if (!this.propertyKeysList || !this.propertyKeysList.property_source) {
        return false;
      }
      const selectedSource = this.propertyKeysList.property_source.find(
        source => source.id === this.property.property_source_id
      );
      return selectedSource && selectedSource.name === 'User';
    },
    propertyType() {
      if (!this.property.building_type) return [];
      return this.enumMaps[this.property.building_type] || [];
    },
    propertyKeysList(){
      const keys = this.$store.getters.propertyKeys;
      // Ensure all required properties exist to prevent template errors
      if (keys) {
        return {
          broker_button: keys.broker_button || false,
          projects: keys.projects || [],
          building_types: keys.building_types || [],
          configuration: keys.configuration || [],
          is_executive: keys.is_executive || false,
          is_hide_owner_details: keys.is_hide_owner_details || false,
          prop_owner_name_req: keys.prop_owner_name_req || false,
          prop_owner_contact_req: keys.prop_owner_contact_req || false,
          posesstion_status: keys.posesstion_status || [],
          land_types: keys.land_types || [],
          lease_types: keys.lease_types || [],
          zones: keys.zones || [],
          proposal_fors: keys.proposal_fors || [],
          status: keys.status || [],
          property_source: keys.property_source || [],
          users: keys.users || [],
          reference_source_ids: keys.reference_source_ids || [],
          area_units: keys.area_units || [],
          priorities: keys.priorities || []
        };
      }
      return {
        broker_button: false,
        projects: [],
        building_types: [],
        configuration: [],
        is_executive: false,
        is_hide_owner_details: false,
        prop_owner_name_req: false,
        prop_owner_contact_req: false,
        posesstion_status: [],
        land_types: [],
        lease_types: [],
        zones: [],
        proposal_fors: [],
        status: [],
        property_source: [],
        users: [],
        reference_source_ids: [],
        area_units: [],
        priorities: []
      };
    },
    showProceed() {
      // Basic validation - can be enhanced based on requirements
      return this.property.property_for && 
             this.property.property_from && 
             this.property.building_type && 
             this.property.property_type;
    }
  }
}
</script>
